module.exports = __webpack_public_path__ + "img/OverseaMember69.fbaf7f8b.png";